import { axiosClientPortalInstance } from "./";

/**
 * Client Portal in-app notifications (PROLINE-3641).
 *
 * Base path (relative to the client-portal axios instance):
 *   /client_portal_notifications
 *
 * Endpoints:
 *   GET   /client_portal_notifications        -> list (resets the unseen count to 0)
 *   PATCH /client_portal_notifications/:id     -> mark a single notification as seen
 */

/**
 * GET /client_portal_notifications — `params`: `{ page, items, locale }`; `config`: axios
 * options, e.g. `{ background: true }`.
 */
const getClientPortalNotifications = async (params, config) =>
  await axiosClientPortalInstance.get(`/client_portal_notifications`, {
    params,
    ...config,
  });

/** PATCH /client_portal_notifications/:id — no body; backend sets `is_seen: true`. */
const setClientPortalNotificationSeen = async (id) =>
  await axiosClientPortalInstance.patch(`/client_portal_notifications/${id}`);

export { getClientPortalNotifications, setClientPortalNotificationSeen };
